import React from "react"
import QustionTitle from "../component/QustionTitle"
import QuestionSelect from "../component/QuestionSelect"
import { get, postFormData } from "../network/request"
import '../style/common.css'
import './QuestionPage.css'


class QuestionPage extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      questionList: [],
      currentIndex: 0,

      currentQuestion: {},
      currentQuestionList: [],

      answerQuestionIds: [],
      answerContents: [],
      
      isSubmitting: false
    }

  }

  componentDidMount() {

    this.getQuestionList()
  }


  getQuestionList() {
    // 获取用户UserId
    let userInfo = localStorage.getItem("initUser")
    let userJson = JSON.parse(userInfo);
    var userId = userJson["user_id"]; // 默认值为空字符串
    var workType = userJson["jobType"] || "1"; // 默认值为1


    console.log("用户ID:", userId);
    // 用户Id类型不能为空
    if (!userId || userId === "undefined" || userId === "" || userId == 0) {
      console.error("用户ID不能为空");
      return;
    }
    // 根据用户的工作类型获取问题列表
    get("/jobQuestion", {"userId": userId, "jobType": workType, "sceneType": "2"}) 
      .then(response => {
        if (response && response["success"] == true && response.data) {
          let questionList = response.data.map((item, index) => {
    
            item.questionModel.questionArr = item.questionModel.questionArr.map((questionItem, index) => {
              return {
                title: questionItem,
                select: false,
                question_type: item.question_type,
                index : index
              }
            })

            item.questionModel.id = item.id
            item.questionModel.question_id = item.question_id
            item.questionModel.index = index
            item.questionModel.question_type = item.question_type
            return item.questionModel
          })

          this.setState({
            questionList: questionList,
            currentQuestion: questionList[0],
            currentIndex: 0,
            currentQuestionList : questionList[0].questionArr
          })
        }
      })
      .catch(error => {
        console.error("数据获取失败:", error);
      });
  }


  clickQuestBtn = (indexNum) => {
    // 处理选择题目逻辑
    const questionType = this.state.currentQuestion.question_type;
    const isMultiselect = questionType == 2;
    let tempQuestion = [];

    if (isMultiselect) {
      // 多选题：切换点击选项的选中状态
      this.state.currentQuestionList.forEach((item, index) => {
        if (index === indexNum) {
          item.select = !item.select;
        }
        tempQuestion.push(item);
      });
    } else {
      // 单选题：只能选择一个选项
      this.state.currentQuestionList.forEach((item, index) => {
        item.select = (index === indexNum);
        tempQuestion.push(item);
      });
    }

    // 更新当前题目列表
    this.setState({
      currentQuestionList: tempQuestion
    });
  }

  clickNextBtn = () => {
    // 检查是否已选择答案
    let selectQuestionList = this.state.currentQuestionList.filter((item) => {
      return item.select === true;
    });

    if (selectQuestionList.length == 0) {
      alert("Please select at least one option.");
      return;
    }

    // 验证单选题只能选择一个选项
    if (this.state.currentQuestion.question_type == 1 && selectQuestionList.length > 1) {
      alert("Please select only one option for single choice question.");
      return;
    }

    // 保存当前题目的答案
    let answerIds = [];
    selectQuestionList.forEach((item) => {
      if (item.select) {
        answerIds.push(item.index);
      }
    });

    // Array To String
    let answerIdsStr = answerIds.join(',');
    let questionId = this.state.currentQuestion.question_id;

    if (this.state.currentIndex < this.state.questionList.length - 1) {
      // 不是最后一题，保存答案并切换到下一题
      this.setState((prevState) => ({
        answerQuestionIds: [...prevState.answerQuestionIds, questionId],
        answerContents: [...prevState.answerContents, answerIdsStr]
      }));

      let tempIndex = this.state.currentIndex + 1;
      let tempOneDic = this.state.questionList[tempIndex];
      let questionArr = tempOneDic.questionArr;

      this.setState({
        currentIndex: tempIndex,
        currentQuestion: tempOneDic,
        currentQuestionList: questionArr,
      });
    } else {
      // 最后一题，直接提交答案（包含当前题目）
      let userInfo = localStorage.getItem("initUser");
      let userJson = JSON.parse(userInfo);
      var userId = userJson["user_id"];

      // 构建提交数据（包含当前题目的答案）
      const allAnswerQuestionIds = [...this.state.answerQuestionIds, questionId];
      const allAnswerContents = [...this.state.answerContents, answerIdsStr];

      const formData = new FormData();
      formData.append("userId", userId);
      formData.append("questionIds", allAnswerQuestionIds.join(';'));
      formData.append("answerContents", allAnswerContents.join(';'));
      formData.append("sceneType", "2");

      this.setState({ isSubmitting: true });


      postFormData("/answerQuestion", formData)
        .then(response => {
          if (response && response["success"] === true) {
            // 提交成功后，清除答案状态
            this.setState({
              answerQuestionIds: [],
              answerContents: [],
              isSubmitting: false
            });

            userJson["jobQuestionType"] = true
            localStorage.setItem("initUser", JSON.stringify(userJson));


            this.props.onClick();
          } else {
            console.error("提交失败:", response);
            this.setState({ isSubmitting: false });
          }
        })
        .catch(error => {
          console.error("数据提交失败:", error);
          this.setState({ isSubmitting: false });
        });
    }
  }


  render() {
    const totalQuestions = this.state.questionList.length;
    const currentProgress = totalQuestions > 0
      ? ((this.state.currentIndex + 1) / totalQuestions) * 100
      : 0;

    const isMultiselect = this.state.currentQuestion.question_type == 2;

    return (
      <div className="QuestionPageV">
        {/* 顶部进度条 */}
        <div className="questionProgressBar">
          <div className="progressFill" style={{ width: `${currentProgress}%` }}></div>
        </div>

        {/* 题目计数 */}
        <div className="questionHeader">
          <div className="questionTitleV">
            <p className="qustionTitle1">BaoBounty</p>
            <p className="qustionTitle2">Daily Challenge</p>
          </div>
          <div className="questionCounter">
            <span>{this.state.currentIndex + 1}</span>
            <span className="counterSeparator">/</span>
            <span>{totalQuestions}</span>
          </div>
        </div>

        {/* 问题内容区域 */}
        <div className="questionContentWrapper">
          <div className="questionNumberBadge">
            Q{this.state.currentIndex + 1} {isMultiselect ? '(Multiple Choice)' : '(Single Choice)'}
          </div>
          <QustionTitle title={this.state.currentQuestion.title}></QustionTitle>

          <div className="optionsList">
            {this.state.currentQuestionList.map((item, index) => {
              return (
                <QuestionSelect
                  key={index}
                  title={item.title}
                  showStats={item.select === true}
                  multStatus={isMultiselect}
                  onClick={() => this.clickQuestBtn(index)}
                />
              )
            })}
          </div>
        </div>

        {/* 底部按钮区域 */}
        <div className="buttonContainer">
          <div className="QustionNextBtn" onClick={this.clickNextBtn}>
            <p className="nextL">
              {this.state.currentIndex < totalQuestions - 1 ? 'Next' : 'Submit'}
            </p>
          </div>
        </div>
      </div>
    )
  }
}

export default QuestionPage